<app-page-header title="Ancillary Management" subtitle="Configure and manage ancillary services and options">
    <div actions>
        <p-button label="Add New" (click)="openAdd()"></p-button>
    </div>
</app-page-header>
<div class="table-card">
    <p-confirmpopup />
    <p-dialog [(visible)]="displayDialog" [modal]="true" [header]="dialogHeader" [closable]="true" [style]="{ width: '420px' }">
        <app-ancillary-create-edit
            [mode]="dialogMode"
            [data]="dialogData"
            (cancel)="onDialogCancel()"
            (save)="onDialogSave($event)"
        ></app-ancillary-create-edit>
    </p-dialog>
    <p-table
        #dt
        [value]="ancillaries"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="[
            'ancillaryKey',
            'status',
            'providerCode',
            'fareTypeName',
            'categoryName',
            'uiDisplayText',
            'mandatorySelection'
        ]"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="providerCode" class="text-left">
                    <div class="flex items-center gap-2">
                        Provider
                        <p-sortIcon field="providerCode"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="providerCode" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="fareTypeName" class="text-left">
                    <div class="flex items-center gap-2">
                        Fare Type
                        <p-sortIcon field="fareTypeName"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="fareTypeName" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="ancillaryKey" class="text-left">
                    <div class="flex items-center gap-2">
                        Service Key
                        <p-sortIcon field="ancillaryKey"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="ancillaryKey" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="uiDisplayText" class="text-left">
                    <div class="flex items-center gap-2">
                        UI Display Text
                        <app-column-filter [table]="dt" type="text" field="uiDisplayText" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="categoryName" class="text-left">
                    <div class="flex items-center gap-2">
                        Category
                        <p-sortIcon field="categoryName"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="categoryName" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="mandatorySelection" class="w-[170px] text-left">
                    <div class="flex items-center gap-2">
                        Mandatory Selection
                        <p-sortIcon field="mandatorySelection"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="mandatorySelection" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="status" class="w-[100px] text-left">
                    <div class="flex items-center gap-2">
                        Status
                        <p-sortIcon field="status"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="status" display="menu"></app-column-filter>
                    </div>
                </th>

                <th class="w-[120px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.providerCode }}</td>
                <td>{{ row.fareTypeName }}</td>
                <td>{{ row.ancillaryKey }}</td>
                <td>
                    <div class="text-sm text-slate-600">
                        @for (item of row.titlesByLanguage | keyvalue; track $index) {
                            {{ item.key }}: {{ item.value }}
                            <br />
                        }
                    </div>
                </td>
                <td>{{ row.categoryName }}</td>
                <td>{{ row.mandatorySelection }}</td>
                <td>
                    <p-select
                        [options]="statusOptions"
                        [(ngModel)]="row.status"
                        (onChange)="onStatusChange($event, row)"
                        [appendTo]="'body'"
                        optionLabel="label"
                        optionValue="value"
                        [style]="{ width: '120px' }"
                    >
                    </p-select>
                </td>

                <td class="text-right">
                    <div class="flex gap-2 justify-end">
                        <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="onEdit(row)"></p-button>
                        <p-button [text]="true" severity="danger" icon="pi pi-trash" (click)="confirmDelete($event, row)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
